// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2OGJG","amount":"Amount_amount__d8caX","tip":"Amount_tip__1vux0","tipHeader":"Amount_tipHeader__3nE8w","tipsWrap":"Amount_tipsWrap__18O3-"};